module.exports = __webpack_public_path__ + "static/media/remove.f6e86831.svg";